import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Btn, Card, Spinner, TextArea } from "./ui";
import { errMsg } from "./api";

export const Config = ({ client }) => {
  const [cfg, setCfg] = useState(null);
  const [instr, setInstr] = useState("");
  const [logs, setLogs] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    client.get("/config").then((r) => { setCfg(r.data); setInstr(r.data.instrucciones || ""); });
    client.get("/auditoria", { params: { limit: 100 } }).then((r) => setLogs(r.data)).catch(() => {});
  }, [client]);

  const save = async (body, msg) => {
    setBusy(true);
    try {
      const { data } = await client.put("/config", body);
      setCfg(data);
      toast.success(msg);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  if (!cfg) return <Spinner />;
  const url = `${window.location.origin}/#/biblioteca`;

  return (
    <div className="space-y-6" data-testid="red-config">
      <Card title="Biblioteca pública">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div className="text-sm text-[#374151]">
            <p>Estado: <strong data-testid="config-publica-estado" className={cfg.biblioteca_publica ? "text-emerald-700" : "text-gray-500"}>{cfg.biblioteca_publica ? "ACTIVADA" : "DESACTIVADA"}</strong></p>
            <p className="text-xs text-gray-500 mt-1">Muestra solo contenidos aprobados marcados como “biblioteca pública”, en <span className="font-mono">{url}</span>. Al activarla aparece “Biblioteca” en el menú del sitio.</p>
          </div>
          <Btn variant={cfg.biblioteca_publica ? "danger" : "gold"} busy={busy} onClick={() => save({ biblioteca_publica: !cfg.biblioteca_publica }, cfg.biblioteca_publica ? "Biblioteca pública desactivada" : "Biblioteca pública activada")} data-testid="config-toggle-publica">
            {cfg.biblioteca_publica ? "Desactivar" : "Activar"}
          </Btn>
        </div>
      </Card>
      <Card title="Gira de la Esperanza pública">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div className="text-sm text-[#374151]">
            <p>Estado: <strong data-testid="config-gira-estado" className={cfg.gira_publica ? "text-emerald-700" : "text-gray-500"}>{cfg.gira_publica ? "ACTIVADA" : "DESACTIVADA"}</strong></p>
            <p className="text-xs text-gray-500 mt-1">Muestra solo las visitas marcadas como públicas, en <span className="font-mono">{window.location.origin}/#/gira</span>. Al activarla aparece “Gira” en el menú del sitio.</p>
          </div>
          <Btn variant={cfg.gira_publica ? "danger" : "gold"} busy={busy} onClick={() => save({ gira_publica: !cfg.gira_publica }, cfg.gira_publica ? "Gira pública desactivada" : "Gira pública activada")} data-testid="config-toggle-gira">
            {cfg.gira_publica ? "Desactivar" : "Activar"}
          </Btn>
        </div>
      </Card>
      <Card title="Instrucciones de grabación y publicación">
        <p className="text-xs text-gray-500 mb-2">Las ven los colaboradores en su portal.</p>
        <TextArea rows={9} value={instr} onChange={(e) => setInstr(e.target.value)} data-testid="config-instrucciones" />
        <Btn className="mt-3" busy={busy} onClick={() => save({ instrucciones: instr }, "Instrucciones guardadas")} data-testid="config-guardar-instrucciones">Guardar</Btn>
      </Card>
      <Card title="Registro de acciones">
        <div className="max-h-96 overflow-y-auto text-sm divide-y" data-testid="config-auditoria">
          {logs.length === 0 ? <p className="text-gray-400">Sin acciones registradas.</p> : logs.map((l) => (
            <div key={l.id} className="py-2 flex flex-wrap gap-x-3">
              <span className="text-xs text-gray-500 w-36 shrink-0">{new Date(l.fecha).toLocaleString("es-AR")}</span>
              <span className="font-medium">{l.actor_nombre}</span>
              <span className="text-xs uppercase tracking-wider text-[#0A2463]">{l.accion.replace(/_/g, " ")}</span>
              <span className="text-gray-600 truncate">{l.detalle}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Config;
